import fa from "element-ui/src/locale/lang/fa";

export {
  introduces
}

let introduces=[
  {
    title: '关于中鹏',
    text: '中鹏（浙江）机械有限公司是以生产破碎机、制砂机、洗选设备等矿山机械为主的，集研究、制造、销售为一体的现代机械制造企业。' +
      '中鹏机械除拥有一批具有十年设计经验的专业人才外，还拥有一流的管理人员及专业的优秀员工，生产的破碎筛分设备全部以欧美、日本等国外的先' +
      '进技术及工艺为标准，各种性能指标已达到或超过国际先进水平为目标。',
    titleEnglish: 'Company profile',
    english: 'Zhejiang Taizhou Jiaojiang Minwei Mining Machinery Business Department is a modern machinery manufacturing enterprise integrating research, manufacture and sales, which mainly   produces mining machinery, s-uch as crusher, sand making machine and washing equipment, etc.\n' +
      'Minwei Machinery boasts a number of professionals with ten-year design experience, first-  class management personnel and excellent professional staffs. All the crushing and screening   equipments are based on the standards of European, American and Japanese advanced technologies   and techniques. All the performance indicators have reached or exceeded the international advanced  level.',
    img:require('@/assets/images/introduce/introduce1.png'),
    isLeft: true,
    isWhite: false
  },
  {
    title: '服务理念',
    text:'服务是企业客户服务中至关重要的环节。我们始终将客户的要求作为我们工作的起点和终点，我们坚持为客户提供从设备选型到安装调试、人员培训、技术支持、设备维修的全套服务。' +
      '签订合同前，确认客户的要求，为客户推荐最合适的设备和最合理的生产流程，提高产量，降低成本。根据客户的具体要求设计、制造产品，组织力量按照客户要求对产品要求进行技术改造。' +
      '签订合同后，公司将选派经过严格训练的技术人员对客户的生产现场进行考察，协助客户对现场进行规划设计，并由技术部制作出安装地基图纸，再由技术员协助客户进行施工。设备运输到以后，' +
      '我公司人  员会协助客户安装、调试直至客户满意。公司免费为客户培训技术人员，让客户掌握设备的使用、维护和  简单修理技术。在生产过程中一旦设备出现故障，' +
      '公司在接到客户电话后的24小时内必须拿出明确的解决方 案，并将以先恢复生产再追究责任的态度迅速解决问题。',
    titleEnglish: 'Senice faith',
    english: 'Service is one of the most important parts in the whole business. We are always devoted to meeting customer\'s need. We insist on providing customers with one-stop service, from model' +
      'choosing, installation and test run, personnel training, technical support to maintenance.\n' +
      '1.Before service: Before the contract is signed, we will act as a good adviser and assistant to help customers choose the most suitable equipment and production line, all for the capacity increasing and stomers.' +
      '2.During and after service: After the contract is signed,(1)we will send our most experienced technicians to make an inspection of the working site,(2)our technicians will help customers make a decision on site planning and designing,(3)technology department will offer a installation foundation drawing,(4)finally, technicians will assist customer in the construction.' +
      'When all the equipment has been delivered to the site, our company will send staff to assist customer in installation and run test. Out company will also provide cust-\n' +
      'omer with free training to help customer master the use and simple maintenance of the machines. Once the machine is out of order at work, our company will\n' +
      'set up a clear solution duting 24 hours after customer\'s phone call. Recover the production first, and then ascertain where responsibility lies.\n',
    img:require('@/assets/images/introduce/introduce2.png'),
    isLeft: false,
    isWhite: true
  }
]
